import { render } from "./MainContent.vue?vue&type=template&id=ce1f765a"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/arturo/Documentos/interfase/proyecto/id-antel/bio-web-client/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__